// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ky","dropMenu":"kz","dropMenuInner":"kA","itemborder":"kB","dropDownCurrent":"kC","menuItem":"kD","langContainer":"kE","current":"kF","outlink":"kG"};